import { render, staticRenderFns } from "./ClientRequestNew.vue?vue&type=template&id=913cb5fc&scoped=true"
import script from "./ClientRequestNew.vue?vue&type=script&lang=js"
export * from "./ClientRequestNew.vue?vue&type=script&lang=js"
import style0 from "./ClientRequestNew.vue?vue&type=style&index=0&id=913cb5fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913cb5fc",
  null
  
)

export default component.exports